exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-release-list__table th[data-v-6fbf4c94] {\n  width: 100px;\n}\n.memo[data-v-6fbf4c94] {\n  width: 30%;\n  word-break: break-all;\n  padding-right: 8%;\n}\n", ""]);

// exports
